import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Terms() {
  const navigate = useNavigate();
  
  const tmStyle = {
    fontSize: '0.5em',
    verticalAlign: 'super'
  };
  
  return (
    <div className="legal-page">
      <h1>Terms of Service</h1>

      <p><strong>Last updated:</strong> September 6, 2026</p>

      <section className="terms-acceptance">
        <h2>Acceptance of These Terms</h2>
        <p>
          These terms govern access to the NeuLogic<span style={tmStyle}>™</span> website and use of NeuLogic software. By downloading, installing, purchasing, activating, or using NeuLogic software, you agree to these terms. If you do not agree, do not use the software.
        </p>
      </section>
      
      <section className="terms-licensing">
        <h2>Software Licenses</h2>
        <p>
          NeuLogic software may be offered as free software, an evaluation version, or a paid product. A paid license grants a limited, non-exclusive right to use the purchased application. The software and all associated intellectual property remain the property of NeuLogic.
        </p>
        <p>
          License scope, device limits, machine-binding requirements, and evaluation restrictions may differ by application. A machine-bound license may be used only on the computer for which it was issued. A license may not be shared, resold, transferred, or used to activate more installations than its terms permit.
        </p>
      </section>

      <section className="terms-evaluation">
        <h2>Evaluation Versions</h2>
        <p>
          An evaluation version may limit particular features, alter evaluation output, display evaluation notices, or require a license for continued or unrestricted use. The applicable limitations are determined by the application.
        </p>
      </section>

      <section className="terms-purchases">
        <h2>Purchases and Activation</h2>
        <p>
          Payments are processed by Stripe. The price, product, and payment terms displayed at checkout apply to the purchase. After a successful payment, NeuLogic may require license activation using information generated by the purchased application. Providing an incorrect application, machine code, or activation request may prevent the license from working.
        </p>
      </section>

      <section className="terms-usage">
        <h2>Permitted Use and Restrictions</h2>
        <p>
          NeuLogic software may be used only for lawful purposes. You may not redistribute, resell, sublicense, publish, or make the software or a license available to another person without written permission. You may not reverse engineer, decompile, disassemble, bypass licensing controls, or attempt to derive the software's source code except where applicable law expressly permits it.
        </p>
      </section>

      <section className="terms-userdata">
        <h2>User Data and Backups</h2>
        <p>
          You remain responsible for the files, information, and storage locations used with NeuLogic software. Where an application creates, changes, moves, encrypts, or deletes important data, maintain an independent backup before using those functions.
        </p>
      </section>
      
      <section className="terms-updates">
        <h2>Updates and Support</h2>
        <p>
          Updates, compatibility changes, and technical support may vary by application and are not guaranteed unless specifically stated on the applicable product page or at the time of purchase.
        </p>
      </section>

      <section className="terms-thirdparty">
        <h2>Third-Party Services</h2>
        <p>
          The website or software may link to or interact with third-party services, including Stripe. Those services are governed by their own terms and privacy policies, and NeuLogic is not responsible for their availability or operation.
        </p>
      </section>

      <section className="terms-disclaimer">
        <h2>Disclaimer</h2>
        <p>
          To the fullest extent permitted by law, the website and software are provided "as is" and "as available," without warranties of any kind, express or implied. NeuLogic does not guarantee that every application will meet every requirement or operate without interruption or error in every environment.
        </p>
      </section>

      <section className="terms-liability">
        <h2>Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, NeuLogic is not liable for indirect, incidental, special, consequential, or punitive damages, or for loss of data, revenue, profits, or business opportunities resulting from use of or inability to use the website or software.
        </p>
      </section>

      <section className="terms-changes">
        <h2>Changes to These Terms</h2>
        <p>
          These terms may be updated when NeuLogic's website, software, licensing, or business practices change. The date above identifies the current version. Continued use after an update constitutes acceptance of the revised terms.
        </p>
      </section>
      
      <section className="terms-contact">
        <h2>Contact</h2>
        <p>
          For questions about these terms or our software, please contact <a href="mailto:support@neulogic.tech">support@neulogic.tech</a>.
        </p>
      </section>
      
      <div className="productpage-actions productpage-actions-row" style={{justifyContent:'flex-start', marginTop:'80px'}}>
        <button className="card-btn productpage-btn-small" onClick={() => navigate('/')} type="button" style={{cursor:'pointer'}}>&larr; Home</button>
      </div>
    </div>
  );
}
